import FloatingUiController from '../../javascript/controllers/floating_ui'

export default class TooltipController extends FloatingUiController {
  connect() {
    super.connect()
    this.fixupDOM()
  }

  fixupDOM() {
    super.fixupDOM()
    this.element.classList.add('tooltip-container')
    this.popupTarget.classList.add('tooltip')
  }
}
